/**
 * Intersection Observer — animate elements into view
 *
 * Usage in HTML: add `data-animate` attribute to any element.
 * Optional: data-animate-delay="200" (ms delay)
 *
 * CSS needed (add to global.scss or a dedicated animations partial):
 *   [data-animate] { opacity: 0; transform: translateY(24px); transition: opacity 0.6s ease, transform 0.6s ease; }
 *   [data-animate].is-visible { opacity: 1; transform: none; }
 */

import { qsa } from './utils.js';

export function initAnimations() {
	// Respect prefers-reduced-motion
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		qsa( '[data-animate]' ).forEach( ( el ) => el.classList.add( 'is-visible' ) );
		return;
	}

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( ! entry.isIntersecting ) return;
				const delay = entry.target.dataset.animateDelay ?? 0;
				setTimeout( () => entry.target.classList.add( 'is-visible' ), Number( delay ) );
				observer.unobserve( entry.target );
			} );
		},
		{ threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
	);

	qsa( '[data-animate]' ).forEach( ( el ) => observer.observe( el ) );
}
